import { v4 as uuid } from "uuid";

export const minTokenSliderValue = 1;
export const maxTokenSliderValue = 1000000;

export const defaultWalletSliderData = [1, 1000000];

export const minWalletSliderValue = 1;
export const maxWalletSliderValue = 1000000;

export const defaultLastActivitySelectInputList = [
  "1 day",
  "3 days",
  "1 week",
  "1 month",
  "3 months",
  "6 months",
  "1 year",
];

export const defaultSpecificInteractionsSelectInputList = [
  "DEX",
  "CEX",
  "Buy NFT",
  "Mint token",
];

export const defaultCustomInteractionsInputList = [
  { id: uuid(), interaction_name: "", contract_address: "" },
];
